import { CancelButton } from 'components/button/button.styled'
import { useDeleteDialog } from 'hooks/admin/useDeleteDialog'
import { useWizard } from 'hooks/admin/useWizard'
import { useGeneratedEventId } from 'hooks/admin/useWizard/useGenerateEventId'
import React from 'react'
import { EventDetails } from 'types/Event'

import { RemoveContainer } from './eventWizard.style'
import { FirstStep } from './steps/FirstStep'
import { SecondStep } from './steps/SecondStep'
import { ThirdStep } from './steps/ThirdStep'

interface EventWizardProps {
    initialData?: EventDetails
    onDelete?: (event_id: string) => Promise<void>
    partnerId?: string
}

export const EventWizard: React.FC<EventWizardProps> = ({ initialData, onDelete, partnerId }) => {
    const { currentStep, eventData, handleNextStep, handlePreviousStep, isEditMode } = useWizard({ initialData })
    const { show: showDeleteDialog, DialogComponent: DeleteDialog } = useDeleteDialog()
    const { generatedEventId, generateEventId } = useGeneratedEventId()

    const handleDelete = () => {
        if (onDelete && eventData?.event_id) {
            showDeleteDialog(() => onDelete(eventData.event_id))
        }
    }

    generateEventId()
    return (
        <div>
            {currentStep === 1 && (
                <FirstStep onNext={handleNextStep} eventData={eventData} partnerId={partnerId} generatedEventId={generatedEventId} />
            )}
            {currentStep === 2 && (
                <SecondStep
                    onNext={handleNextStep}
                    onPrevious={handlePreviousStep}
                    eventData={eventData}
                    generatedEventId={generatedEventId}
                    initialEventLocationId={eventData.location?.event_location_id}
                    initialLocationId={eventData.location_id}
                    partnerId={partnerId}
                    isEditMode={isEditMode}
                />
            )}
            {currentStep === 3 && (
                <ThirdStep
                    onPrevious={handlePreviousStep}
                    eventData={eventData}
                    generatedEventId={generatedEventId}
                    isEditMode={isEditMode}
                    partnerId={partnerId}
                />
            )}

            {isEditMode && onDelete && (
                <RemoveContainer>
                    <CancelButton label="Esemény törlése" icon="pi pi-times" onClick={handleDelete} />
                </RemoveContainer>
            )}
            <DeleteDialog entityLabel={'az eseményt'} />
        </div>
    )
}
